export default __webpack_public_path__ + "static/media/honda.2589be5e.svg";